import { render, staticRenderFns } from "./wip.vue?vue&type=template&id=87f1442c&"
import script from "./wip.vue?vue&type=script&lang=js&"
export * from "./wip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports